<template>
  <div class="relative bottom-0 left-0 right-0 p-3 footerBg dark:bg-black">
    <div
      class="flex flex-wrap items-center justify-center mx-auto md:justify-between maxWidth lg:px-0 md:px-4"
    >
      <div class="flex items-center text-sm font-bold">
        <a href="#home-page" class="h-[20px]">
          <Muneeb />
        </a>

        <span class="">|</span>
        <span class="pl-3 text-sm font-normal dark:text-white">
          © {{ currentYear }}. All Rights Reserved</span
        >
      </div>
      <h1 class="text-sm font-normal dark:text-white">
        Designed by
        <span class="font-semibold textBlue"> Mogamat Muneeb Davids</span>
      </h1>
    </div>
  </div>
</template>

<style scoped>
.footerBg {
  background: #f0f0f0;
}
</style>

<script>
import { useDark, useToggle } from "@vueuse/core";
import Muneeb from "../components/icons/Muneeb.vue";
export default {
  setup() {
    const currentYear = new Date().getFullYear();
    const isDark = useDark();
    const toggleDark = useToggle(isDark);
    // console.log(isDark.value);
    return { isDark, toggleDark, currentYear };
  },
  components: { Muneeb },
};
</script>
